/* Flat, saturated pills with white text and a soft shadow, no border — solid
   badge look so tags read clearly against the cream page background. */
const tagPalette = [
  'bg-red-500 text-white shadow-sm hover:bg-red-600',
  'bg-amber-400 text-white shadow-sm hover:bg-amber-500',
  'bg-red-400 text-white shadow-sm hover:bg-red-500',
  'bg-amber-500 text-white shadow-sm hover:bg-amber-600',
  'bg-orange-500 text-white shadow-sm hover:bg-orange-600',
  'bg-yellow-500 text-white shadow-sm hover:bg-yellow-600',
];

export const getTagColor = (name: string) => {
  const hash = Array.from(name).reduce((value, character) => value + character.charCodeAt(0), 0);
  return tagPalette[hash % tagPalette.length];
};

export const getStaticTagColor = (name: string) =>
  getTagColor(name).split(' ').filter((className) => !className.startsWith('hover:')).join(' ');
